<div class="flex align-items-center border-round-2xl bg-black-alpha-40 px-2 py-1">
  <!-- Botón Play/Pause -->
  <!-- <a pButton [icon]="isPlaying ? 'fa fa-pause' : 'fa fa-play'" class=" p-button-rounded" (click)="togglePlay()">
  </a> -->
  <a pButton pRipple type="button" [icon]="isPlaying ? 'fa fa-pause' : 'fa fa-play'" (click)="togglePlay()"
      class="p-button-rounded p-button-text p-button-danger text-white hover:text-blue-400">
            </a>

  <!-- Barra de progreso -->
  <div class="flex flex-column w-full">
    <input type="range" class="w-full" [value]="currentTime" [max]="duration"
           (input)="audio.currentTime = $any($event.target).value" />
    <div class="flex justify-content-between text-sm text-500">
      <span class="text-white text-xs">{{ formatTime(currentTime) }}</span>
      <span class="text-white text-xs">{{ formatTime(duration) }}</span>
    </div>
  </div>
</div>
